<template>
    <div class="container box">
        <div class="columns">
            <div class="column is-four-fifths">
                <div class="notification" style="text-align: left" :class="classObject">
                    <span class="icon"><i class="fas fa-terminal" aria-hidden="true"></i></span> &nbsp; &nbsp;<strong>{{statusText}}</strong>
                </div>
                <div class="field">
                    <label class="label">JMESPath</label>
                    <div class="control has-icons-left">
                        <input type="text" class="input" placeholder="Enter JMESPath..." v-model="testPath"
                               @keyup="updateTheSource"/>
                        <span class="icon is-small is-left">
              <i class="fas fa-search"></i>
            </span>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">Source Object</label>
                            <div class="control">
                                <textarea class="textarea" placeholder="Enter Source Object..." rows="16"
                                          v-model="sourceObject" @keyup="updateTheSource"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field">
                            <label class="label">Result</label>
                            <div class="control">
                                <textarea class="textarea has-background-light" rows="16" v-model="outputObject"
                                          readonly></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <nav class="panel">
                    <p class="panel-heading">History</p>
                    <p class="panel-block">
                        <span class="panel-icon">
                <i class="fas fa-clock" aria-hidden="true"></i>
                    </span>
                        <a class="button is-primary is-fullwidth" :disabled="!isSaveHistoryEligible" @click="!!isSaveHistoryEligible && saveHistory()">
                        <small>Save Current</small>
                    </a></p>
                    <a class="panel-block" v-for="(item, index) in history" @click="loadItem(index)" :key="item.name">
                        <small>{{item.name}}</small>
                        &nbsp;<button class="delete is-small" @click.stop="removeItem(index)"></button>

                    </a>

                    <p class="panel-heading">
                        Examples
                    </p>
                    <a class="panel-block" @click.prevent="loadJmespathExample">
                <span class="panel-icon">
                  <i class="fas fa-file-code" aria-hidden="true"></i>
                </span>
                        <small>Official Example</small>
                    </a>
                    <p class="panel-heading">
                        Actions
                    </p>
                    <a class="panel-block" @click.prevent="tidySource">
                <span class="panel-icon">
                  <i class="fas fa-align-left" aria-hidden="true"></i>
                </span>
                        <small>Tidy Source</small>
                    </a>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'underscore'

    export default {
        name: 'Inputs',
        props: {
            msg: String
        },
        data() {
            var JMESPath = require('jmespath');

            return {
                testPath: '',
                sourceObject: '',
                outputObject: '',
                statusText: 'Fill in path and source',
                status: 'INFO',
                JMESPath: JMESPath,
                history: []
            }
        },
        created: function () {
            var history = JSON.parse(localStorage.getItem('history'));
            if(history && _.isArray(history)){
                this.history = history;
            } else{
                this.history = [];
            }
        },
        computed: {
            isSaveHistoryEligible : function () {
                if(this.status != 'SUCCESS') {
                    return false;
                }
                var last    = this.history[this.history.length-1];
                var current = {
                    testPath        : this.testPath,
                    sourceObject    : this.sourceObject
                };
                if(last && last.testPath === current.testPath && last.sourceObject === current.sourceObject){
                    return false;
                }
                return true;
            },
            classObject: function () {
                return {
                    "is-info": (!this.status || this.status === 'INFO'),
                    "is-success": this.status && ['SUCCESS'].indexOf(this.status) !== -1,
                    "is-warning": this.status && ['WARNING', 'INVALID_JSON'].indexOf(this.status) !== -1,
                    "is-danger": this.status && ['DANGER', 'SEARCH_FAILED'].indexOf(this.status) !== -1
                }
            }
        },
        methods: {
            loadItem: function (index) {
                this.sourceObject = this.history[index].sourceObject;
                this.testPath = this.history[index].testPath;

                this.updateTheSource();
            },
            tidySource: function () {
                try {
                    this.sourceObject = JSON.stringify(JSON.parse(this.sourceObject), null, 2);
                    this.statusText = 'Source tidied.';
                    this.status = 'SUCCESS';
                } catch (err) {
                    this.statusText = 'JSON must be valid to tidy';
                    this.status = 'INVALID_JSON';
                }
            },
            loadJmespathExample: function () {
                this.testPath = "locations[?state == 'WA'].name | sort(@) | {WashingtonCities: join(', ', @)}";
                this.sourceObject =
`{
   "locations": [
     {"name": "Seattle", "state": "WA"},
     {"name": "New York", "state": "NY"},
     {"name": "Bellevue", "state": "WA"},
     {"name": "Olympia", "state": "WA"}
   ]
 }`;
                this.updateTheSource()
            },
            updateTheSource: function (event) {

                if (this.sourceObject == "" || this.testPath == "") {
                    this.statusText = 'Fill in path and source';
                    this.status = 'INFO';
                    return;
                }
                this.outputObject = '';

                try {
                    var parsed = JSON.parse(this.sourceObject);
                } catch (err) {
                    this.statusText = 'Waiting for valid JSON Source';
                    this.status = 'INVALID_JSON';

                    return;
                }
                this.status = 'INFO';
                this.statusText = 'Parsing...';
                try {
                    var result = this.JMESPath.search(parsed, this.testPath);
                    if (typeof result !== "undefined") {
                        this.statusText = 'Updated!';
                        this.outputObject = JSON.stringify(result, null, 2);
                    } else {
                        this.outputObject = '';
                        this.statusText = 'Updated... but empty result';
                    }

                    this.status = 'SUCCESS';

                } catch (err) {
                    this.statusText = 'The Search Failed ' + err;
                    this.status = 'SEARCH_FAILED';


                }
            },
            saveHistory: function (event) {
                var d = new Date();

                var item = {
                    name: d.toLocaleDateString() + ' ' + d.toLocaleTimeString(),
                    sourceObject: this.sourceObject,
                    testPath: this.testPath
                };
                this.history.push(item);
                localStorage.setItem('history', JSON.stringify(this.history));
            },
            removeItem: function (index) {
                this.history.splice(index, 1);
                localStorage.setItem('history', JSON.stringify(this.history));
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "~bulma/css/bulma.css";

    .dropdown {
        width: 100%;

        .dropdown-trigger {
            width: 100%
        }

        .button {
            display: flex;
            width: 100%;
            justify-content: space-between
        }

    }
</style>
